import {observer} from "mobx-react";
import {useContext} from "react";
import {Button, Typography} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import InfoIcon from "@mui/icons-material/Info";
import {Frame} from "../common/Frame";
import {RecordingStoreContext} from "../../stores/RecordingStore";
import {VideoPlayer} from "../video/VideoPlayer";

interface RecordingContentPanelProps {
  videoRef: React.RefObject<HTMLVideoElement | null>;
  onOpenInfo: () => void;
}

export const RecordingContentPanel = observer(({videoRef, onOpenInfo}: RecordingContentPanelProps) => {
  const store = useContext(RecordingStoreContext);
  const theme = useTheme();

  if (!store) return null;

  return (
    <Frame grow direction="column" padding={2.5} gap={2.5} style={{overflow: 'hidden'}}>
      {/* Video Section */}
      <Frame direction="column" gap={1.5} grow style={{display: 'flex', flexDirection: 'column', minHeight: 0}}>
        <Frame row alignItems="center" justifyContent="space-between">
          <Typography variant="h6" fontWeight={600}>
            Recording
          </Typography>
          <Button
            variant="outlined"
            startIcon={<InfoIcon />}
            onClick={onOpenInfo}
            size="small"
          >
            Session Info
          </Button>
        </Frame>
        <Frame
          grow
          style={{
            minHeight: 0,
          }}
        >
          {store.videoUrl ? (
            <VideoPlayer
              videoRef={videoRef}
              src={store.videoUrl}
              annotations={store.annotations}
              selectedAnnotation={store.selectedAnnotation}
              onAnnotationSelect={(annotation) => {
                // Prevent selecting other annotations while editing
                if (store.editingAnnotation && annotation !== store.editingAnnotation) {
                  return;
                }
                store.selectedAnnotation = annotation;
              }}
              editMode={!!store.editingAnnotation}
              onAnnotationBoundsChange={(annotation, startMs, endMs) => {
                annotation.startMs = startMs;
                annotation.endMs = endMs;
              }}
              limitToAnnotation={store.selectedAnnotation}
              onTimeUpdate={(ms) => store.setCurrentTime(ms)}
              aspectRatio={store.videoAspectRatio}
            />
          ) : (
            <Frame grow center radius={2} style={{backgroundColor: theme.palette.background.paper}}>
              <Typography variant="body1" color="text.secondary">
                Video will appear here once available.
              </Typography>
            </Frame>
          )}
        </Frame>
      </Frame>
    </Frame>
  );
});
